import baseCRUDAPI from './baseCRUDAPI';

export default class BrandStoryFavorite extends baseCRUDAPI {
  constructor(baseURLPath) {
    super(baseURLPath);
    this.apiBaseName = '/brandStoryFavorite';
  }
}
